import { render, staticRenderFns } from "./UploadAssetTypeImage.vue?vue&type=template&id=224e34f6&"
import script from "./UploadAssetTypeImage.vue?vue&type=script&lang=js&"
export * from "./UploadAssetTypeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports